export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_07.11854544.mp4";